import { bool, number, oneOf, oneOfType, string } from "prop-types";
import { useEffect, useRef, useState } from "react";

import styled from "styled-components";
import {
  border,
  borderRadius,
  height,
  themeSizes,
  themeVariants,
  width,
} from "theme";
import { widthBySize } from "theme/constants";

import { unoBackupSrc } from "Flocknote/constants";

import FnrOpacityToggle from "UI/FnrOpacityToggle";

const SFnrOpacityToggle = styled(FnrOpacityToggle)`
  line-height: 0px;
`;

const Simg = styled("img")`
  ${borderRadius}
  ${border}
  ${width}
  ${height}
  object-fit: cover;
`;

const circle = "circle";
const square = "square";

/**
 * @param {object} param0
 * @param {string} param0.src - the url of the image
 * @param {size} param0.size - the size of the image
 * @param {"square"|"circle"} param0.shape - the shape of the image
 * @param {string} param0.color - the color of the border/background
 * @returns
 */
const FnrNetworkPhoto = ({
  src,
  size = themeSizes.md,
  width: widthArg,
  shape = circle,
  color = "white",
  thick = true,
  noBorder,
  ...rest
}) => {
  const [loadFailed, setLoadFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isMountedRef = useRef();

  // if the source changes, try again.
  useEffect(() => {
    if (!isMountedRef.current) {
      isMountedRef.current = true;
      return;
    }
    setLoadFailed(false);
    setIsLoading(true);
  }, [src]);

  return (
    <SFnrOpacityToggle show={!isLoading} {...rest}>
      <Simg
        $size={size}
        $width={widthArg}
        $height={widthBySize[size] || widthArg}
        aria-label="Network photo"
        $variant={
          shape === circle ? themeVariants.icon : themeVariants.container
        }
        $color={color}
        $thick={thick}
        $noBorder={noBorder}
        src={(loadFailed ? unoBackupSrc : src) || unoBackupSrc}
        onError={() => {
          setLoadFailed(true);
          setIsLoading(false);
        }}
        onLoad={() => {
          setIsLoading(false);
        }}
      />
    </SFnrOpacityToggle>
  );
};

FnrNetworkPhoto.propTypes = {
  src: string,
  size: oneOf(Object.values(themeSizes)),
  width: number,
  shape: oneOf([square, circle]),
  color: string,
  thick: oneOfType([bool, number]),
  noBorder: bool,
};

export default FnrNetworkPhoto;
